import React, { useState } from 'react';
import { Pagination } from 'antd';
import { cnTblPagination, cnTblPaginationDataMessage } from './TableStyleConstants';

interface IProps {
	recordsCount: number,
	currentPage: number,
	totalPages: number,
	pageSize: number,
	/** What type of data is being represented? */
	dataType?: string | undefined,
	rowsPerPageOptions?: string[] | undefined,
	onPageChange?: (newPage: number) => void | undefined,
	onRowsPerPageChange?: (newPage: number, newRowsPerPage: number) => void | undefined
}

function TablePagination(props: IProps) {
	const [state, setState] = useState({
		pageSize: props.pageSize
	})

	function onPageChange(page: number, pageSize: number | undefined) {
		if (props.onPageChange) props.onPageChange(page);
	}

	function onShowSizeChange(currentPage: number, newSize: number) {
		console.log('newSize', newSize);
		setState({ ...state, pageSize: newSize });
		if (props.onRowsPerPageChange) props.onRowsPerPageChange(currentPage, newSize);
	}

	const pageSizeOptions = props.rowsPerPageOptions ? props.rowsPerPageOptions : ['15', '25', '50']

	return (
		<div className={cnTblPagination}>
			<Pagination
				pageSize={state.pageSize}
				total={props.recordsCount}
				showSizeChanger={true}
				current={props.currentPage}
				onShowSizeChange={onShowSizeChange}
				onChange={onPageChange}
				pageSizeOptions={pageSizeOptions}
				showQuickJumper={true}
			/>
			{props.dataType &&
				<p className={cnTblPaginationDataMessage}>
					Showing {props.pageSize} of {props.recordsCount} {props.dataType}
				</p>
			}
		</div>
	);
};

export default TablePagination;